import { FileInfo } from '@types'
import { toVector3 } from '@utils/conversion/toVector3'

export const baseParams = {
  method: 'GET',
  mode: 'cors',
  headers: {
    'Accept-Language': 'ES',
    'Content-Type': 'application/json',
    Authorization: 'Ninpo ' + sessionStorage.getItem('access_token'),
  },
}

//DON'T TOUCH OR LOGIC MAY BREAK
export const EXTRA_DIMENTIONS_DISTANCE = 0 as const
export const BASE_ANGLE_SNAP_DEGREES = 10 as const
export const variation = BASE_ANGLE_SNAP_DEGREES / (Math.PI * 180)
export const MORPHS_DICTIONARY_EN_TO_ES = {
  thickness: 'Fondo',
  height: 'Alto',
  width: 'Ancho',
}
export const MORPHS_DICTIONARY_ES_TO_EN = {
  Fondo: 'thickness',
  Alto: 'height',
  Ancho: 'width',
}
export const ninetyDeg = Math.PI / 2
export const max0 = variation
export const min0 = -variation
export const max90 = ninetyDeg + variation
export const min90 = ninetyDeg - variation
export const oneEightyDeg = Math.PI
export const max180 = -oneEightyDeg + variation
export const min180 = oneEightyDeg - variation
export const twoSeventyDeg = -Math.PI / 2
export const max270 = twoSeventyDeg - variation
export const min270 = twoSeventyDeg + variation
export const pi = oneEightyDeg
export const halfPi = ninetyDeg
export const piFourths = oneEightyDeg / 4
export const piEighths = oneEightyDeg / 8
export const pipi = 2 * pi //This one is fun sorry but can't write 2pi as const
export const fourtyFiveDeg = Math.PI / 4
export const oneThirtyFiveDeg = fourtyFiveDeg + ninetyDeg
export const twoTwoFiveDeg = oneEightyDeg + fourtyFiveDeg
export const EPSILON = 1e-6 as const

//Please keep touching if needed below here.
const CAMERA_X = -2000
const CAMERA_Y = 2500
const CAMERA_Z = 10
export const BASE_CAMERA_OBB_SIZE = toVector3([50, 50, 3000])
export const baseCamera3DData = {
  position: toVector3([CAMERA_X, CAMERA_Y, CAMERA_Z]),
  // rotation: new Matrix3(
  //   -0.018978153267001304,
  //   4.85722573273506e-16,
  //   0.9998198986310356,
  //   0.1679044926387397,
  //   0.9857981151338453,
  //   0.00318709119500285,
  //   -0.9856205715437871,
  //   0.16793473791493485,
  //   -0.018708627719331197,
  // ),
  zoom: 1,
}
export const baseCamera2DData = { position: toVector3([0, 9900, 0]), zoom: 0.15 }
export const lastView = { position: toVector3([0, 0, 0]), target: toVector3([0, 0, 0]) }
export const baseLayers = [
  {
    layerID: 0,
    name: 'layer-0',
    order: 0,
    opacity: 1,
    altitude: 0,
    items: new Set<string>(),
    areas: new Set<string>(),
    selected: new Set<string>(),
    deltas: new Map<
      string,
      Array<{ targetId: string; deltaX: number; deltaY: number; deltaZ: number }>
    >(),
    rotationSnapshot: null as {
      anchorId: string
      items: Record<
        string,
        {
          position: [number, number, number]
          quaternion: [number, number, number, number]
        }
      >
    } | null,
  },
]
export const emptyClientInfo = {
  nombreProyecto: '',
  descripcion: '',
  nombre: '',
  apellidos: '',
  direccion: '',
  codPostal: '',
  poblacion: '',
  email: '',
  pais: '',
  movil: '',
  numProyectoTpc: '',
  idDisenos: 0,
  idVersiones: 0,
  idImpuestos: 0,
  disenadorActual: null,
  disenadorOriginal: null,
}

export const emptyFileInfo: FileInfo = {
  fileName: '',
  reference: '',
  fileDescription: '',
  longDescription: '',
  url: '',
  originalExtension: 'gltf',
  glbBlob: new Blob(),
  newExtension: 'glb',
  width: 0,
  height: 0,
  depth: 0,
  placementHeight: 0,
  unit: 'cm',
  tipoNormalizado: 'otros',
  glbUrl: '',
  jpgUrl: '',
  price: 0,
  folder: '',
  pngBlob: new Blob(),
  glbBase64: '',
}

export const baseTextos = {
  idioma: {
    id: 1,
    codigo: 'ES',
    nombreCultura: 'ES',
    idioma: 'Español',
  },
  textos: {} as Record<string, string>,
}
